import React from 'react';

export const UserInfo = React.createContext({
    info: null,
    get: () => {},
    request: null
})
